<h2>COME ASSOCIARSI - BENEMERITI</h2>
<p>
	La scelta dei benemeriti viene gestita con procedure interne all'Associazione.
	<br>
	Si diventa Soci benemeriti solo dietro invito, pervenuto tramite email dal Presidente.
</p>
<p>
	Per accettare l'invito ad associarsi, l'interessato dovrà,
	entro 30 giorni dalla ricezione dell'invito:
</p>
<ul>
	<li>
		Compilare l'invito ricevuto
	</li>
	<li>
		Leggere e sottoscrivere <a href="../../../assets/associazione/Informativa_privacy.pdf">l'Informativa sul
			trattamento dei dati personali</a>.
	</li>
	<li>
		Effettuare il pagamento della quota associativa di Euro 550,00.
	</li>
	<li>
		Inviare i seguenti documenti all'indirizzo
		email <a href="mailto:soci@decifris.it">soci&#64;decifris.it</a>:
		<ul>
			<li>
				L'invito controfirmato,
			</li>
			<li>
				L'informativa sul trattamento dei dati sottoscritta,
			</li>
			<li>
				La ricevuta del pagamento,
			</li>
			<li>
				Una copia di un documento d'identità (carta d'identità o passaporto).
			</li>
		</ul>
	</li>
</ul>
<h3>MODALITA' DI PAGAMENTO:</h3>
<p>
	Pagamento tramite bonifico su conto corrente intestato a:
	<br>
	Associazione De Componendis Cifris
	<br>
	IBAN: IT 61 Q 08304 01810 000010412063
	<br>
	BIC/SWIFT: CCRTIT2T76A
	<br>
	Cassa di Trento Credito Cooperativo Italiano
	<br>
	Causale: “Quota socio/a benemerito/a Nome Cognome”.
</p>